import utils from "../../../utils/utils.js";

export default {
  async fetchEngagementCategories(context, payload) {
    const pageNumber = payload.pageNumber;
    const pageSize = payload.pageSize;
    const sortColumn = payload.sortColumn;
    const sortDirection = payload.sortDirection;
    const searchText = payload.searchText;
    const categoryType = payload.categoryType;
    const status = payload.status;

    const responseData = await utils.utility.fetch(
      `api/Setting/GetEngagementCategories?categoryType=${categoryType}&pageNumber=${pageNumber}&pageSize=${pageSize}&sortColumn=${sortColumn}&sortDirection=${sortDirection}&searchText=${searchText}&status=${status}`,
      "GET",
      null,
      null
    );
    context.commit("setEngagementCategories", {
      categoryType: categoryType,
      categories: responseData.data,
    });
  },

  async fetchEngagementCategoriesForSelect(context, payload) {
    const pageNumber = payload.pageNumber;
    const pageSize = payload.pageSize;
    const sortColumn = payload.sortColumn;
    const sortDirection = payload.sortDirection;
    const searchText = payload.searchText;
    const categoryType = payload.categoryType;
    const status = payload.status !== undefined ? payload.status : -1;

    const responseData = await utils.utility.fetch(
      `api/Setting/GetEngagementCategories?categoryType=${categoryType}&pageNumber=${pageNumber}&pageSize=${pageSize}&sortColumn=${sortColumn}&sortDirection=${sortDirection}&searchText=${searchText}&status=${status}`,
      "GET",
      null,
      null
    );
    context.commit("setEngagementCategoriesForSelect", {
      categoryType: categoryType,
      categories: responseData.data,
    });
  },

  async fetchExportEngagementCategories() {
    await utils.utility.fetch(
      `api/Setting/GetExportEngagementCategories`,
      "GET",
      null,
      null
    );
  },

  async postEngagementCategory(context, payload) {
    await utils.utility.fetch(
      `api/Setting/CreateEngagementCategory`,
      "POST",
      null,
      payload
    );
  },
  async putEngagementCategory(context, payload) {
    await utils.utility.fetch(
      `api/Setting/UpdateEngagementCategory`,
      "PUT",
      null,
      payload
    );
  },

  async deleteEngagementCategory(context, payload) {
    let postData = { id: payload.id,categoryType: payload.categoryType, };
    await utils.utility.fetch(
      `api/Setting/DeleteEngagementCategory`,
      "POST",
      null,
      postData
    );
  },
};
